import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { TEMPLATE_PATH } from '../api';
import { SmsTemplateCreateInterface, SmsTemplateUpdateInterface } from '../types';
export const useSmsTemplateActions = () => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.put
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: updateFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.post
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    fetcher: duplicateFetcher
  } = useFetch(t3);
  let t4;
  if ($[4] !== fetcher) {
    t4 = template => fetcher(TEMPLATE_PATH, template);
    $[4] = fetcher;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== updateFetcher) {
    t5 = template_0 => updateFetcher(TEMPLATE_PATH, template_0);
    $[6] = updateFetcher;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== deleteFetcher) {
    t6 = id => deleteFetcher(TEMPLATE_PATH + "/" + id);
    $[8] = deleteFetcher;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== duplicateFetcher) {
    t7 = id_0 => duplicateFetcher(TEMPLATE_PATH + "/duplicate/" + id_0);
    $[10] = duplicateFetcher;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = {
      createSmsTemplate: t4,
      updateSmsTemplate: t5,
      deleteSmsTemplate: t6,
      duplicateSmsTemplate: t7
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};